import React from "react";
export const VehicleDetailContext = React.createContext(null);
export const useVehicleDetailContext=() => {
    const context= React.useContext(VehicleDetailContext);
    if (!context) throw new Error ("Vehicle Detail Context not provided!");
    return context;

};